import { _bemHelper, bemErrorHelper } from "../FieldHelpers";
import "./ErrorField.scss";

export const ErrorField = (props: {
  name?: string;
  errorMessage: string | null | undefined;
  valid: boolean;
  className?: string;
}) => {
  const namespace = "error-field";
  return (
    <>
      {props.errorMessage && (
        <div
          data-testid={`error-field-${props.name ?? ""}`}
          className={
            bemErrorHelper(namespace, props.valid) +
            ` ${props.className ? _bemHelper(namespace, props.className) : ""}`
          }
        >
          {props.errorMessage}
        </div>
      )}
    </>
  );
};
